/**
 * Wraps an activity page in the base styles the activities front had globally
 * (TRAV23 activities-front merge).
 *
 * The ported stylesheets were authored on top of Bootstrap 5 plus the Vite React
 * template; RSI loads neither, so without this wrapper headings lose their colour,
 * paragraphs pick up RSI's `p` rule, the layout stops centring and the accent colour
 * reverts to RSI's blue. `_base-compat.scss` explains exactly what is reproduced and
 * why it cannot simply be loaded globally.
 *
 * Every page under `/activities` renders inside one of these.
 */

import type { ReactNode } from 'react';

import './styles.scss';

interface IProps {
  children: ReactNode;
}

export function ActivityScope({ children }: IProps) {
  return <div className="activities-scope">{children}</div>;
}
